import Axios from 'axios';
import { getPathName, getApiHash, getApiToken } from './helper';

const obtenerProvincias = async () => {
    const params = {
        hash: await getApiHash(),
        provincia: ""
    }
    const headers = {
        'content-type': 'application/json',
        "Authorization": 'Bearer ' + await getApiToken()
    }

    let endpoint = "/getprovinciasjson"
    if (process.env.REACT_APP_DEV_MODE === "true") {
        if(process.env.REACT_APP_PAIS == "uy") endpoint = "/getdepartamentosjson"
    } else {
        const hostname = window.location.hostname;
        if (hostname.endsWith(".com.uy")) {
            endpoint = "/getdepartamentosjson"
        } else {
            endpoint = "/getprovinciasjson"
        }
    }

    return await Axios.post(await getPathName() + endpoint, params,
        {
            headers: headers
        }).then(function (response) {
            return response.data.provincias.sort((a, b) => a.localeCompare(b))
        }).catch(function (error) {
            return error;
        });
};

export default obtenerProvincias;